import { queryOptions } from '@tanstack/react-query';

import { transcriptApi } from './transcript.api';

export const queryKeys = {
    all: ['transcript'] as const,
    transcript: (id: string) => [...queryKeys.all, id] as const,
    metadata: (id: string) => [...queryKeys.all, id, 'metadata'] as const,
};

export function transcriptOptions(id: string) {
    return queryOptions({
        queryKey: queryKeys.transcript(id),
        queryFn: ({ signal }) => transcriptApi.getById(id, signal),
        staleTime: Infinity,
    });
}

export function transcriptMetadataOptions(id: string = '') {
    return queryOptions({
        queryKey: queryKeys.metadata(id),
        queryFn: ({ signal }) => transcriptApi.getMetadata(id, signal),
        staleTime: Infinity,
        enabled: !!id,
    });
}
